import { useQuery } from '@tanstack/react-query';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { featureFlagsQueryOptions } from '@/app/services/features';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';

export const IN_CLINIC_URL_FLAG = 'In_Clinic_Url';

export const IN_CLINIC_PATH = '/in-clinic';
export const LEGACY_CHUTE_IMPLANT_PATH = '/chute-implant';

export const getInClinicBasePath = (isInClinicUrl: boolean) =>
  isInClinicUrl ? IN_CLINIC_PATH : LEGACY_CHUTE_IMPLANT_PATH;

export const useInClinicBasePath = () =>
  getInClinicBasePath(useFeatureFlag(IN_CLINIC_URL_FLAG));

export const resolveInClinicApiUrl = (url: string, isInClinicUrl: boolean) =>
  isInClinicUrl
    ? url
    : url.replace(/^\/api\/in-clinic/, `/api${LEGACY_CHUTE_IMPLANT_PATH}`);

export const InClinicPathGate = () => {
  const { pathname, search } = useLocation();
  const { data: flags, isPending } = useQuery(featureFlagsQueryOptions());

  if (isPending) return null;

  const basePath = getInClinicBasePath(flags?.[IN_CLINIC_URL_FLAG] ?? false);
  if (!pathname.toLowerCase().startsWith(basePath)) {
    return (
      <Navigate
        replace
        to={{
          pathname: pathname.replace(/^\/(chute-implant|in-clinic)/i, basePath),
          search,
        }}
      />
    );
  }

  return <Outlet />;
};
